<template>
  <div>
    <div
      class="n-value-row"
      v-for="(d, i) of getDataSet(data)"
      :key="i"
    >
      <div
        class="n-value-first-col"
        :style="`width: ${firstColumnWidth}px`"
        v-html="d.label"
      ></div>
      <div class="n-value-cells">
        <div
          class="n-value-cell"
          v-for="(v, j) of d.data"
          :key="j"
          :style="`flex-basis: ${valuesColumnWidth}px`"
        >
          <span
            class="n-value"
            :class="d.style"
          >{{ v }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NValueTable",
  props: {
    data: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
    },
    rows: {
      type: Number,
      required: true,
      default: 2,
    },
    valuesColumnWidth: {
      type: Number,
      required: true,
    },
    firstColumnWidth: {
      type: Number,
      required: true,
    },
    config: {
      type: Object,
      required: true,
    },
  },

  methods: {
    getDataSet(data) {
      const { type, rows } = this;
      const dataset = data ?? [];

      if (type === 'regular') {
        return dataset.slice(0, rows);
      }

      if (type === 'show-all-series') {
        return dataset;
      }

      return [];
    },
  },
};
</script>

<style lang="scss" scoped>
  .n-value-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-family: Roboto, sans-serif;
    font-size: rem(10);
    color: #646464;

    @include iPadProStyles {
      font-size: rem(12);
    }

    & + .n-value-row {
      margin-top: 2px;
    }
  }

  .n-value-cells {
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
  }

  .n-value-first-col {
    text-align: right;
    line-height: 1;
  }

  .n-value-cell {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .n-value {
    display: inline-block;
    line-height: 22px;
    width: 75%;
    text-align: center;

    &.solid {
      background: rgba(0, 109, 138, 0.16);
    }
  }
</style>
